import { render } from "./HeaderChallengeLeaderboard.vue?vue&type=template&id=26a37484&scoped=true"
import script from "./HeaderChallengeLeaderboard.vue?vue&type=script&lang=js"
export * from "./HeaderChallengeLeaderboard.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge-leaderboard.css?vue&type=style&index=0&id=26a37484&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a37484"]])

export default __exports__